module.exports = __webpack_public_path__ + "static/media/random-300.3155c748.png";